var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChildrenPage',{attrs:{"id":1,"imgs":[
  require('../assets/imgs/1-1.png'),
  require('../assets/imgs/1-2.png'),
  require('../assets/imgs/1-3.png')
  ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }